import AuthorItem from "@app/components/author-item";
import Pagination from "@app/components/pagination";
import SkeletonGrid from "@app/components/skeleton-grid";
import {
  DEFAULT_PAGE,
  DEFAULT_REQUEST_PARAMS,
  RoutePath,
} from "@app/constants";
import AuthorService from "@app/services/http/author.service";
import { Author, Meta } from "@app/types";
import useCancellationRequest from "@core/hooks/use-cancellation-request.hook";
import { RequestParams } from "@core/services/http/http.type";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function AuthorList() {
  const { abortController } = useCancellationRequest();

  const [authors, setAuthors] = useState<Author[]>([]);
  const [requestParams, setRequestParams] = useState<RequestParams>({
    ...DEFAULT_REQUEST_PARAMS,
    pageSize: 50,
  });
  const [meta, setMeta] = useState<Meta>();
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    AuthorService.getList(requestParams, abortController.signal)
      .then((res) => {
        setAuthors(res.data.items);
        setMeta(res.data.meta);

        if (
          requestParams.pageNum &&
          res.data.meta.totalPage > 0 &&
          res.data.meta.totalPage < requestParams.pageNum
        ) {
          const newRequestParams: RequestParams = {
            ...requestParams,
            pageNum: DEFAULT_PAGE,
          };

          setRequestParams(newRequestParams);
        }

        window.scrollTo({ top: 0, behavior: "smooth" });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [requestParams]);

  const onPageChange = (page: number) => {
    const newRequestParams: RequestParams = {
      ...requestParams,
      pageNum: page,
    };

    setRequestParams(newRequestParams);
  };

  const handleItemClick = (authorId: number) => {
    navigate(`${RoutePath.AUTHOR}/${authorId}`);
  };

  return (
    <div className="px-[100px] min-h-[calc(100vh-328px)]">
      <div className="mt-[66px]">
        <div className="text-[#171A20] font-[SVN-Gilroy] font-bold text-[32px]">
          Tác Giả Nổi Bật
        </div>
      </div>
      {!loading && authors.length ? (
        <div>
          <div className="mt-9 flex flex-wrap gap-6">
            {authors.map((author) => (
              <div
                key={author.id}
                className="cursor-pointer"
                onClick={() => handleItemClick(author.id)}
              >
                <AuthorItem author={author} />
              </div>
            ))}
          </div>
          {meta && (
            <div className="flex justify-center mt-3">
              <Pagination
                currentPage={meta.pageNum}
                totalPages={meta.totalPage}
                onPageChange={onPageChange}
              />
            </div>
          )}
        </div>
      ) : (
        <div className="mt-9">
          <SkeletonGrid />
        </div>
      )}
    </div>
  );
}

export default AuthorList;
